import gql from 'graphql-tag';

export const WeatherAndMarineReadingFragments = {
  id: gql`
    fragment WeatherAndMarineReadingId on WeatherAndMarineReading {
      id
    }
  `,
};
